import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../../images/case-studies/novelcraft/tek_img_12.webp";

function HighlightNovel() {
  return (
    <section
      className="high_last_novel p-100"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="mx-auto">
            <h2>The Highlights</h2>
          </Col>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="mx-auto">
            <p>
              The fluid graphics, character details and animations are what
              makes Novelcraft stand out. We made sure that each character’s
              animation delivered the best experience possible for fans and
              gamers to enjoy.
            </p>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mx-auto text-center"
          >
            <div className="img_boxing">
              <StaticImage
                src="../../../images/case-studies/novelcraft/tek_img_11.webp"
                alt="novelcraft TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1600}
                height={647}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default HighlightNovel;
